import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';
import palette from '@utils/theme/palette';
import Tooltip from '@components/ui/Tooltip/next';

import { BadgeContainer, TextContainer } from './styled';

const Badge = ({
  icon,
  text,
  isGuestsSuggests,
}: {
  icon: any;
  text: string;
  isGuestsSuggests?: boolean;
}) => {
  return isGuestsSuggests ? (
    <Tooltip
      overlayInnerStyle={{
        textAlign: 'center',
        width: '250px',
        backgroundColor: palette.NL0,
        padding: '8px',
      }}
      arrowColor={palette.NL0}
      overlayStyle={{
        backgroundColor: palette.NL0,
        borderRadius: '8px',
      }}
      placement='topLeft'
      title={
        <Typography variant='caption2' color='D500' weight='Light'>
          Setur misafir memnuniyeti anketleri baz alınmıştır. Anketlere katılan
          misafirlerin çoğunluğunun memnun olduğu oteller seçilmiştir.
        </Typography>
      }
      getPopupContainer={(node) => node}
    >
      <BadgeContainer>
        <CustomIcon icon={icon} fontSize={16} paletteColor='NL800' />
        <TextContainer>
          <Typography
            variant='caption3'
            weight='Regular'
            color='NL800'
            css={{ whiteSpace: 'nowrap' }}
          >
            {text}
          </Typography>
        </TextContainer>
      </BadgeContainer>
    </Tooltip>
  ) : (
    <BadgeContainer>
      <CustomIcon icon={icon} fontSize={16} paletteColor='NL800' />
      <TextContainer>
        <Typography
          variant='caption3'
          weight='Regular'
          color='NL800'
          css={{ whiteSpace: 'nowrap' }}
        >
          {text}
        </Typography>
      </TextContainer>
    </BadgeContainer>
  );
};

export default Badge;
